import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Observable } from 'rxjs';
import { FindCRSService } from '@app/core/services';
import { mergeMap, map } from 'rxjs/operators';

@Component({
  selector: "app-auto-complete-search",
  templateUrl: "./app-auto-complete-search.component.html",
  styleUrls: ["./app-auto-complete-search.component.scss"]
})
export class AppAutoCompleteSearchComponent implements OnInit {


  public autoSearchNumberOfResult: number = 10;

  public searchSettingsForName: Observable<any>;
  public searchForSettingLocation: Observable<any>;
  public isInvalidBothSearch: boolean = false;

  @Input() searchkeywordForName: string;
  @Input() searchkeywordForLocation: string;
  @Input() searchFailed: boolean;
  @Input() searchSetting: any;
  @Input() placeholderText: string = 'Search here';
  @Input() searchSubmitted: boolean = false;
  @Input() isNormaSearch: boolean = false;


  @Output() onEnter = new EventEmitter();
  @Output() onSelect = new EventEmitter<any>();
  @Output() onKeyUp = new EventEmitter<any>();
  @Output() onInvalidSearch = new EventEmitter<any>();


  constructor(private _findcsrService: FindCRSService) {}

  ngOnInit() {
    this.searchSettingsForName = Observable.create((observer: any) => {
      observer.next(this.searchkeywordForName);
    }).pipe( mergeMap((token: string) => this.searchForAgentName(token)));

    this.searchForSettingLocation = Observable.create((observer: any) => {
      observer.next(this.searchkeywordForLocation);
    }).pipe( mergeMap((token: string) => this.searchForAgentLocation(token)));
  }

  ngDoCheck() {
    if(this.searchkeywordForLocation === 'Places' || this.searchkeywordForLocation === 'Neighborhoods') {
      this.searchkeywordForLocation = '';
    }

    if (this.searchkeywordForName)
      this.onKeyUp.emit(this.searchkeywordForName);
    if (this.searchkeywordForLocation)
      this.onKeyUp.emit(this.searchkeywordForLocation);

    this.isInvalidBothSearch =  this.isInValidSearch() && this.searchSubmitted;
  }

  // Fired every time 'agent' search when string is changed
  searchForAgentName(kwd: string) {
    if (kwd && kwd.toString().trim() && kwd.toString().trim().length > 2) {
      return this._findcsrService.seachAutoComplete(kwd.toString().trim(), this.autoSearchNumberOfResult ,'Name')
        .pipe(
          map(response => {                       
            const returnResponse = [];
            if (response && response.length) {
              response.forEach(element => {                                    
                returnResponse.push(element.FullName);
              });           
              return returnResponse;   
            }
          }))
    } else {                 
      return [];
    }
  }

  // Fired every time 'location' search when string is changed
  searchForAgentLocation(kwd: string) {
    if (kwd && kwd.toString().trim() && kwd.toString().trim().length > 2) {
      return this._findcsrService.seachAutoComplete_Location(kwd.toString().trim(), this.autoSearchNumberOfResult ,'Location')
        .pipe(
          map((response:any) => {

            var returnResponse = [];

            if (response) {
              if (response.Place && response.Place.length) {
                response.Place.forEach(element => {
                  returnResponse.push({ name: element.Location, region: 'Places' });
                });
              }
              if (response.Neighborhoods && response.Neighborhoods.length) {
                response.Neighborhoods.forEach(element => {
                  returnResponse.push({ name: element.Location, region: 'Neighborhoods' });
                });
              }
              return returnResponse;
            }
          }))
    } else {
      return [];
    }
  }

  selectedItem(item: any) {

    this.onSelect.emit(item);
  }

  searchKeyWork() {
    this.searchSubmitted = true;
    if (this.isInValidSearch()) {
      this.onInvalidSearch.emit(true);
      return;
    }
    this.onInvalidSearch.emit(false);
    this.onEnter.emit();
    this.searchSubmitted = false;
  }

  onKeyPress(value: any) {
    this.onKeyUp.emit(value);
  }

  isInValidSearch() {
    if (!this.searchkeywordForName && !this.searchkeywordForLocation) {
      return true;
    }
    let isInvalid = true;
    if (this.searchkeywordForName) {
      if (this.searchkeywordForName.trim()) {
        isInvalid = false;
      }
    }
    if (this.searchkeywordForLocation) {
      if (this.searchkeywordForLocation.trim()) {
        isInvalid = false;
      }
    }

    return isInvalid;
  }
}
